// extracted by mini-css-extract-plugin
module.exports = {"lead":"Typography_lead___KZup","contact":"Typography_contact__3KcVR","legal":"Typography_legal__2xFZV"};